import {Component, OnInit} from '@angular/core';
import {SbLineChartModel} from '@ngx-seatback/charts';

@Component({
  selector: 'sb-bid-impression-rate',
  templateUrl: './bid-impression-rate.component.html',
  styleUrls: ['./bid-impression-rate.component.scss'],
  standalone: false,
})
export class BidImpressionRateComponent implements OnInit {
  constructor() {}

  bidImpressionRate: SbLineChartModel;

  ngOnInit(): void {
    this.bidImpressionRate = {
      title: 'Test',
      height: 150,
      value: 'bid',
      value2: 'impression',
      category: 'day',
      legend: true,
      valueName: 'Bids',
      valueName2: 'Impressions',
      color: '#3E7CB1',
      color2: '#1dc9b7',
      data: [
        {
          day: 1,
          bid: 12000,
          impression: 2000,
        },
        {
          day: 2,
          bid: 19000,
          impression: 5450,
        },
        {
          day: 3,
          bid: 9000,
          impression: 1340,
        },
        {
          day: 4,
          bid: 20000,
          impression: 3940,
        },
        {
          day: 5,
          bid: 14000,
          impression: 1765,
        },
        {
          day: 6,
          bid: 3400,
          impression: 1440,
        },
        {
          day: 7,
          bid: 9000,
          impression: 1340,
        },
      ],
    };
  }
}
